import { Material, Object3D, Vector3 } from "three"
import { sectionFromProgress } from "./landing-motion"

type OpacityMaterial = Material & {
  opacity?: number
  transparent: boolean
  depthWrite: boolean
  userData: { baseOpacity?: number }
}

export function damp(current: number, target: number, lambda = 0.08) {
  return current + (target - current) * lambda
}

export { sectionFromProgress }

export function latLon(lat: number, lon: number, radius: number) {
  const phi = ((90 - lat) * Math.PI) / 180
  const theta = ((lon + 180) * Math.PI) / 180
  return new Vector3(
    -radius * Math.sin(phi) * Math.cos(theta),
    radius * Math.cos(phi),
    radius * Math.sin(phi) * Math.sin(theta),
  )
}

export function applyGroupOpacity(root: Object3D, opacity: number) {
  root.visible = opacity > 0.015
  root.traverse((child) => {
    const material = (child as { material?: Material | Material[] }).material
    if (!material) return
    const materials = Array.isArray(material) ? material : [material]
    materials.forEach((mat) => {
      const m = mat as OpacityMaterial
      if (typeof m.opacity !== "number") return
      if (typeof m.userData.baseOpacity !== "number") m.userData.baseOpacity = m.opacity
      m.transparent = true
      m.opacity = (m.userData.baseOpacity || 1) * opacity
      m.depthWrite = opacity > 0.94 && (m.userData.baseOpacity || 1) > 0.92
    })
  })
}
